import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ModalProvider } from './context/ModalContext';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async'; // ✅ Added

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider> {/* ✅ Wrap entire app */}
      <BrowserRouter>
        <ModalProvider>
          <App />
        </ModalProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

// loader - do not remove it

const MIN_LOADER_TIME = 400;
const startTime = performance.now();

const removeLoader = () => {
  const loader = document.getElementById('page-loader');
  if (!loader) return;

  const elapsed = performance.now() - startTime;
  const remainingTime = Math.max(0, MIN_LOADER_TIME - elapsed);

  setTimeout(() => {
    loader.remove();
  }, remainingTime);
};

// Handle both fast & slow loads
if (document.readyState === 'complete') {
  removeLoader();
} else {
  window.addEventListener('load', removeLoader);
}

reportWebVitals();
